﻿import type { Address, Contact, EventOrganizer, ItemReference } from '@/types'
import axios, { eventsAuthenticatedAxios } from './axios'
import { isAxiosError } from 'axios'

const path = `event-organizers`

// BacklogTrace: HR-001
function normalizeEventOrganizer(data: EventOrganizer) {
    data.contact ??= {} as Contact
    data.address ??= {} as Address
    return data as EventOrganizer
}

export async function getEventOrganizerById(id: string, partitionKey: string) {
    const { data } = await axios.get<EventOrganizer>(`${path}/ref/${partitionKey}/${id}`)
    return normalizeEventOrganizer(data)
}
export async function getEventOrganizerByIdAndPartitionKeyApi(id: string, partitionKey: string) {
    const { data } = await axios.get<EventOrganizer>(`${path}/ref/${partitionKey}/${id}`)
    return normalizeEventOrganizer(data)
}

export async function getEventOrganizersBatch(itemReferences: ItemReference[]) {
    if (!itemReferences.length) {
        return [] as EventOrganizer[]
    }

    const { data } = await eventsAuthenticatedAxios.post<EventOrganizer[]>(
        `${path}/batch`,
        itemReferences
    )

    return data.map(normalizeEventOrganizer)
}

export async function getEventOrganizerByTypeId(typeId: number) {
    try {
        const { data } = await axios.get<EventOrganizer[]>(`${path}/type/${typeId}`)
        return data as EventOrganizer[]
    } catch (error) {
        if (isAxiosError(error) && error.response?.status === 404) {
            return [] as EventOrganizer[]
        }

        throw error
    }
}
export async function createEventOrganizer(userId: string, event: EventOrganizer) {
    const { data } = await eventsAuthenticatedAxios.post<EventOrganizer>(`${path}`, event, {
        params: { userId }
    })
    return data
}
export async function updateEventOrganizer(event: EventOrganizer) {
    const { data } = await eventsAuthenticatedAxios.put<EventOrganizer>(`${path}`, event)
    return data
}
export async function deleteEventOrganizerById(id: string, partitionKey: string, userId: string) {
    try {
        const { data } = await eventsAuthenticatedAxios.delete<EventOrganizer[]>(
            `${path}/${partitionKey}/${id}`,
            { params: { userId } },
        )
        return data
    } catch (error) {
        if (isAxiosError(error) && error.response?.status === 404) {
            return
        }

        throw error
    }
}
